module.exports = __webpack_public_path__ + "static/media/exdirector.242fb5ed.jpg";